
  import { defineComponent, provide, ref, watch } from 'vue';
  import { StepItemState } from './item.vue';

  export default defineComponent({
    name: 'BaseStep',
    props: {
      active: {
        type: Number,
        default: 0,
      },
    },
    setup(props) {
      const steps = ref([]);
      watch(steps, () => {
        steps.value.forEach((instance: StepItemState, index) => {
          instance.setIndex(index);
        });
      });
      provide('BaseStep', { props, steps });
      return {};
    },
  });
